import React from 'react';
import PropTypes from 'prop-types';
import SVGIcon from './SVGIcon';
import DownloadButton from './public/DownloadButton';
import SelectionNotAvailable from './SelectionNotAvailable';
import { useSelector } from 'react-redux';

const HorizontalBarGraph = props => {
  const topPercentage = props.data[0] ? props.data[0].sharePerCent : 1;
  const topValue = props.data[0] ? props.data[0].value : 1;
  const topBrandAffinityValue = props.data[0] ? props.data[0].brandAffinity : 1;

  const [currentIndex, setCurrentIndex] = React.useState(0);

  const handleLeftButtonClick = () =>
    setCurrentIndex(Math.max(currentIndex - props.barOnScreen, 0));
  const handleRightButtonClick = () => {
    if (currentIndex + props.barOnScreen < props.data.length) {
      setCurrentIndex(
        Math.min(
          currentIndex + props.barOnScreen,
          Math.floor(props.data.length / props.barOnScreen) * props.barOnScreen
        )
      );
    }
  };

  const counter = useSelector(state => state);
  return (
    <React.Fragment>
      {props.isDataAvailable ? (
        <div className="TopTenOrganisations">
          <h3
            className="content-card_title"
            style={{ display: 'inline-block' }}
          >
            {props.title}
          </h3>

          {props.downloadOpen && (
            <DownloadButton
              styleObj={{ display: 'inline-block', float: 'right' }}
              downloadAudience={props.downloadAudience}
              downloadingCSV={props.downloadingCSV}
              reportType={props.reportType}
              insightType={props.insightType}
              downloadParams={props.downloadOpen}
            />
          )}

          <p className="content-card_subtitle">{props.subtitle}</p>

          {props.brandAffinityText && (
            <div className="content-card_brandAffinity-select-text">
              <div>Selected {props.brandAffinityText}</div>
            </div>
          )}

          {props.showSelectionNotAvailable ? (
            <div className="TopTenOrganisations_selectionNotAvailable">
              <SelectionNotAvailable
                text={`No ${props.brandAffinityText} selected`}
                buttonText={`Please select ${props.brandAffinityText}`}
              />
            </div>
          ) : (
            <React.Fragment>
              {props.enableFrequency === true && (
                <div className="TopTenOrganisations_frequencyTitle">
                  [ Weekly
                  <br />
                  Frequency ]
                </div>
              )}
              <ul>
                {props.data
                  .slice(currentIndex, currentIndex + props.barOnScreen)
                  .map((item, idx) => (
                    <li key={idx}>
                      <p className="TopTenOrganisations_chart-title">
                        {item.name}
                      </p>
                      <div className="TopTenOrganisations_info">
                        <div className="TopTenOrganisations_chart">
                          <div
                            className={`TopTenOrganisations_horizontal_graph_bar${
                              item.brandAffinity !== undefined &&
                              item.showingStatus === 'grey'
                                ? '_negative'
                                : ''
                            }`}
                            style={{
                              width: `${
                                item.sharePerCent
                                  ? (item.sharePerCent / topPercentage) * 100
                                  : item.value !== undefined
                                  ? (Math.abs(item.value) / topValue) * 100
                                  : item.showingStatus !== null &&
                                    item.showingStatus === 'grey'
                                  ? 100
                                  : (Math.abs(item.brandAffinity) /
                                      topBrandAffinityValue) *
                                    100
                              }%`,
                            }}
                          />
                        </div>
                        <div className="TopTenOrganisations_percentage">
                          {item.sharePerCent
                            ? Math.round(item.sharePerCent) < 1
                              ? '< 1%'
                              : `${Math.round(item.sharePerCent)}%`
                            : item.value !== undefined
                            ? item.value.toFixed(2)
                            : item.showingStatus !== null &&
                              item.showingStatus === 'grey'
                            ? 'n/a'
                            : `${item.brandAffinity.toFixed(2)}x`}
                        </div>
                        {props.enableFrequency === true && (
                          <div className="TopTenOrganisations_frequency">
                            {item.frequency
                              ? `[ ${item.frequency.toFixed(1)}x ]`
                              : `n/a`}
                          </div>
                        )}
                      </div>
                      <div className="TopTenOrganisations_statistic-container">
                        {props.statisticOpen && (
                          <div className="TopTenOrganisations_statistic">
                            ({' '}
                            {!isNaN(item.penetration)
                              ? (item.penetration * 100).toFixed(2)
                              : item.penetration * 100}
                            % /
                            <span>
                              &plusmn;
                              {!isNaN(item.confidence)
                                ? (item.confidence * 100).toFixed(2)
                                : item.confidence * 100}
                              %
                            </span>
                            )
                            {props.enableFrequency === true && (
                              <span style={{ marginLeft: '5rem' }}>{``} </span>
                            )}
                          </div>
                        )}
                      </div>
                    </li>
                  ))}
              </ul>
            </React.Fragment>
          )}

          {props.buttonOpen && (
            <div className="TopTenOrganisations_button-area">
              <span className="WhereYourCustomersHaveBeenGraph_top-row_showing">
                Showing {currentIndex + 1} -{' '}
                {Math.min(currentIndex + props.barOnScreen, props.data.length)}{' '}
                of {props.data.length}
              </span>
              <div className="WhereYourCustomersHaveBeenGraph_top-row_button-group">
                <button type="button" onClick={() => handleLeftButtonClick()}>
                  <SVGIcon icon="left-arrow" />
                </button>
                <button type="button" onClick={() => handleRightButtonClick()}>
                  <SVGIcon icon="right-arrow" />
                </button>
              </div>
            </div>
          )}
        </div>
      ) : (
        <SelectionNotAvailable
          text="Graph Currently Unavailable"
          buttonText=""
        />
      )}
    </React.Fragment>
  );
};

HorizontalBarGraph.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

HorizontalBarGraph.defaultProp = {
  buttonOpen: false,
  statisticOpen: true,
  subtitle: '',
  barOnScreen: 10,
  selectOptions: [
    {
      label: 'No data',
      value: 'No data',
    },
  ],
};

export default HorizontalBarGraph;
